export * from './applyConfiguration';
